import axios from "axios";
import SkTechApiClient from "../base/SkTechApiClient";
import { UploadFile } from "antd";
import { RcFile } from "antd/es/upload";
import { ConfirmUserItem } from "../../pages/RegisterByInvitation";
import { Education } from "../../models/Education";
import { Skill } from "../../models/Skill";

export default class CommonApiClient extends SkTechApiClient {

  //#region Location Management
  public getCities = async (country: string) => {
    return await axios.post(
      `https://countriesnow.space/api/v0.1/countries/cities`,
      {
        country: `${country}`,
      }
    );
  };

  public getCountries = async () => {
    // return await axios.get("https://restcountries.com/v3.1/all");
  };
  //#endregion


  //#region Education Management
  public getEducation = async (
    country: string,
    city: string,
    language: string
  ) => {
    /* return await axios({
      method: 'get',
      url: `https://localhost:7075/api/University/GetUniversities?country=${country}&city=${city}`
      //url: `https://maps.googleapis.com/maps/api/place/textsearch/json?query=Education+in+${country}+${city}&language=${language}&key=AIzaSyBIRJi8byb-jIg9Yij2rl948wB3Qd0Fh5I`,
    }); */
    return await this.Get(
      `api/ExternalServices/GetUniversities?country=${country}&city=${city}&language=${language}`
    );
  };

  public addEducation = async (
    userId: string,
    country: string,
    city: string,
    university: string,
    profession: string,
    degree: string,
    startDate: string,
    endDate: string
  ) => {
    return await this.Post(`/api/CompanyUsers/AddEducation?userId=${userId}`, {
      country: country,
      city: city,
      university: university,
      profession: profession,
      degree: degree,
      startDate: startDate,
      endDate: endDate,
    })
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public editEducation = async (
    prevItem: Education,
    country: string,
    city: string,
    university: string,
    profession: string,
    degree: string,
    startDate: string,
    endDate: string
  ) => {
    return await this.Post(`/api/CompanyUsers/EditEducation`, {
      prevItem: prevItem,
      country: country,
      city: city,
      university: university,
      profession: profession,
      degree: degree,
      startDate: startDate,
      endDate: endDate,
    })
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public removeEducation = async (
    country: string,
    city: string,
    university: string,
    profession: string,
    degree: string,
    startDate: string,
    endDate: string
  ) => {
    return await this.Post(`/api/CompanyUsers/RemoveEducation`, {
      country: country,
      city: city,
      university: university,
      profession: profession,
      degree: degree,
      startDate: startDate,
      endDate: endDate,
    })
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };
  //#endregion


  //#region Skills Management
  public getSkills = async (): Promise<any> => {
    return await this.Get("/api/Skill")
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public addSkill = async (title: string): Promise<Skill | boolean> => {
    return await this.Post("/api/Skill", {
      title: title,
    })
      .then((response) => {
        if (response.status === 200) {
          return response.data as Skill;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public AssignSkillToUser = async (
    skillId: string,
    userId: number,
    level: number,
    experience: number
  ) => {
    return await this.Get(
      `/api/Skill/AssignSkillToUser?skillId=${skillId}&userId=${userId}&skillLevel=${level}&skillExperienceYears=${experience}`
    )
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public RemoveSkillFromUser = async (skillId: number, userId: number) => {
    return await this.Get(
      `/api/Skill/RemoveSkillFromUser?skillId=${skillId}&userId=${userId}`
    )
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };
  //#endregion


  //#region Event Management
  public GetEvents = async () => {
    return await this.Get(`/api/EventCalendar`)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  };

  public AddEvent = async (value: any) => {
    return await this.Post(`/api/EventCalendar`, value)
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public DeleteEvent = async (id: any) => {
    return await this.Delete(`/api/EventCalendar?id=${id}`)
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };
  //#endregion


  //#region Support Methods
  public SupportRequest = async (value: any) => {
    return await this.Post(`/api/Report/SendReport`, value)
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };
  //#endregion


  //#region Auth Management
  public getConfig = async () => {
    return await this.Get(`api/Auth/config`)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public loginGoogle = async (googleToken: string): Promise<any> => {
    return await fetch(this.BASE_URL + "/api/Auth/google-login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: googleToken }),
    })
      .then((response) => {
        return response.json();
      })
      .then(async function (data) {
        console.log("google-login");
        return data;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public login = async (
    login: string,
    password: string
  ): Promise<true | { error: "LockedOut" | "TooManyAttempts" | "InvalidCredentials" }> => {
    return await this.Post(this.BASE_URL + "/api/Auth/login", {
      email: login,
      password: password,
    })
      .then(function (response) {
        if (response.status === 200) {
          localStorage.setItem("token", response.data.token);
          return true;
        }
        return { error: "InvalidCredentials" as const };
      })
      .catch(function (error) {
        console.log(error);
        const status = error?.response?.status;
        if (status === 423) {
          return { error: "LockedOut" as const };
        }
        if (status === 429) {
          return { error: "TooManyAttempts" as const };
        }
        return { error: "InvalidCredentials" as const };
      });
  };

  public autorize = async (): Promise<any> => {
    try {
      const response = await this.Get("/api/Account/me");
      if (response.status === 200 && response.data?.user) {
        const userData = JSON.parse(response.data.user);
        const userRolesArray = userData.userRoles?.$values || [];
        console.log("XXX2", JSON.parse(response.data.company));
        const mappedUser = {
          ...userData,
          roles: userRolesArray.map((ur: { roleId: number; role: { id: number; title: string } }) => ({
            id: ur.roleId,
            name: ur.role.title,
          }))
        };
        return {
          ...response,
          data: {
            ...response.data,
            user: JSON.stringify(mappedUser)
          }
        };
      }

      return response.status === 200 ? response : false;
    } catch (error) {
      console.error("Error during authorization:", error);
      return false;
    }
  };
  //#endregion


  //#region Job Titles Management
  public getJobTitles = async (): Promise<any> => {
    return await this.Get("/api/JobTitle")
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public addJobTitles = async (
    title: string,
    description?: string
  ): Promise<any> => {
    return await this.Post("/api/JobTitle/AddJobTitle", {
      title: title,
      description: description,
    })
      .then((response) => {
        if (response.status === 200) {
          return response;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };
  //#endregion


  //#region Company & Account Management
  public isApproveInvite = async (
    email: string
  ): Promise<any> => {
    return await this.Get(`/api/Account/IsApproveInvite?email=${email}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
        return true;
      })
      .catch(function (error) {
        console.log(error);
        return true;
      });
  };

  public CompanyCheck = async (name: string): Promise<boolean> => {
    return await this.Get(`/api/Company/Check?companyName=${name}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public companyCreate = async (
    title: string,
    description: string,
    tenant: string,
    countryId: number,
    adress: string,
    tariffplanid: number,
    tariffplaninterval: string
  ): Promise<any> => {
    return await this.Post("/api/CompanyCreate", {
      title: title,
      description: description,
      tenant: tenant,
      countryId: countryId,
      adress: adress,
      tariffplanid: tariffplanid,
      tariffplaninterval: tariffplaninterval,
    })
      .then((response) => {
        console.log(response);

        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public registerByInvitation = async (
    user: ConfirmUserItem
  ): Promise<any> => {
    return await this.Post("/api/Account/RegisterByInvitation", {
      email: user.email,
      token: user.token,
      firstName: user.firstName,
      lastName: user.lastName,
      city: user.city || "",
      phoneNumber: user.phoneNumber || "",
      isPhoneNumberPrivate: user.isPhoneNumberPrivate || false,
      skype: user.skype || "",
      password: user.password,
    })
      .then((response) => {
        console.log(response);

        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };

  public accountRegister = async (
    email: string,
    password: string,
    firstName: string,
    lastName: string,
    companyId: number,
    role: string = "user"
  ): Promise<any> => {
    return await this.Post("/api/Account/register", {
      email: email,
      password: password,
      FirstName: firstName,
      LastName: lastName,
      companyId: companyId,
      role: role,
    })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };
  //#endregion

  
  //#region File Management
  public fileUpload = async (file: UploadFile): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file.originFileObj as RcFile);
    return await this.Post("/api/File/upload", formData)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };
  //#endregion
}
